/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { Grid } from '@mui/material';
import React from 'react'
import { Box } from '@mui/system';
import { BsFillPeopleFill, BsServer } from "react-icons/bs";
import { FaBuilding, FaFileAlt, FaNetworkWired, FaUserCog } from "react-icons/fa";
import { MdSettingsApplications } from "react-icons/md";

import { RiDeviceFill } from 'react-icons/ri';
import ContentCard from '../../../../../components/ui-elements/cards/ContentCard';


const DashboardPage = () => {


    return (
        <>
            <Box m={6}>

                <Grid container spacing={4}  >
                    <Grid item xs={12} sm={6} md={3}>
                        <ContentCard link="/manage-users" title="Users" subTitle="Manage Users" icon={<BsFillPeopleFill />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <ContentCard link="/manage-organizations" title="Organizations" subTitle="Manage Organizations" icon={<FaBuilding />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <ContentCard link="/manage-applications" title="Applications" subTitle="Manage Applications" icon={<MdSettingsApplications />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <ContentCard link="/manage-roles" title="Roles" subTitle="Manage Roles" icon={<FaUserCog />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <ContentCard link="/manage-identity-provider" title="Identity Providers" subTitle="Manage Identity Providers" icon={<BsServer />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <ContentCard link="/manage-devices" title="Devices" subTitle="Manage Devices" icon={<RiDeviceFill />}></ContentCard>
                    </Grid>
                   
                    <Grid item xs={12} sm={6} md={3}>
                        <ContentCard link="/manage-network" title="Network" subTitle="Network Management" icon={<FaNetworkWired />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <ContentCard link="/manage-reports" title="Reports" subTitle="View Reports" icon={<FaFileAlt />}></ContentCard>
                    </Grid>
                </Grid>

            </Box>

        </>
    )

}

export default DashboardPage;
